import { API_URL } from '@/utils/static';
import { getFilenameFromUrl } from '@/utils/helpers/common';
import { api } from '@/api';

//collect already answered questionnaire
const collectQuestionnaireAnswers = (questionnaire) => {
  const values = {};
  let creators = {};
  const preFilledQuestions = {};
  let lastAnsweredSection = -1;

  questionnaire.questionSections.forEach((section, sectionIndex) => {
    section.questionGroups.forEach((questionGroup) => {
      let collectedQuestions = [];

      questionGroup.questions.forEach((question) => {
        if (questionGroup.isMultiple) {
          switch (question.type) {
            case 'DOC_UPLOAD': {
              try {
                const answers = question.answers;
                if (answers && answers.length > 0) {
                  answers.forEach((answer, index) => {
                    const url = `${API_URL}/${answer.documentURL}`;

                    if (answer.preFilled) {
                      preFilledQuestions[`group_${questionGroup.id}.${index}`] = {
                        ...preFilledQuestions[`group_${questionGroup.id}.${index}`],
                        [question.id]: true
                      };
                    }

                    if (answer.creator) {
                      creators[question.id] = {
                        answerId: answer.id,
                        ...answer.creator
                      };
                    }

                    !collectedQuestions[index]
                      ? (collectedQuestions[index] = { [question.id]: url })
                      : (collectedQuestions[index][question.id] = url);
                  });

                  if (answers.filter((answer) => !answer.isRejected).length > 0) {
                    lastAnsweredSection = sectionIndex;
                  }
                }
              } catch (e) {}

              break;
            }
            default: {
              const answers = question.answers;
              if (answers && answers.length > 0) {
                answers.forEach((answer, index) => {
                  if (answer.preFilled) {
                    preFilledQuestions[`group_${questionGroup.id}.${index}`] = {
                      ...preFilledQuestions[`group_${questionGroup.id}.${index}`],
                      [question.id]: true
                    };
                  }

                  if (answer.creator) {
                    creators[question.id] = {
                      answerId: answer.id,
                      ...answer.creator
                    };
                  }

                  !collectedQuestions[index]
                    ? (collectedQuestions[index] = { [question.id]: answer.answer })
                    : (collectedQuestions[index][question.id] = answer.answer);
                });
                if (
                  answers.filter((answer) => !answer.isRejected && !answer.preFilled).length > 0
                ) {
                  lastAnsweredSection = sectionIndex;
                }
              }
            }
          }
        } else {
          switch (question.type) {
            case 'DOC_UPLOAD':
            case 'RECORD_VIDEO':
            case 'SIGNATURE': {
              const answerObj = question.answers[0];
              if (answerObj) {
                values[question.id] = `${API_URL}/${answerObj.documentURL}`;
                if (answerObj.preFilled) preFilledQuestions[question.id] = true;
                if (answerObj.creator) {
                  creators[question.id] = {
                    answerId: answerObj.id,
                    ...answerObj.creator
                  };
                }
                if (!answerObj.isRejected && !answerObj.preFilled)
                  lastAnsweredSection = sectionIndex;
              }
              break;
            }
            case 'RADIO': {
              const answerObj = question.answers[0];
              if (answerObj) {
                values[question.id] = answerObj.availableAnswerId;
                if (answerObj.preFilled) preFilledQuestions[question.id] = true;
                if (answerObj.creator) {
                  creators[question.id] = {
                    answerId: answerObj.id,
                    ...answerObj.creator
                  };
                }
                if (!answerObj.isRejected && !answerObj.preFilled)
                  lastAnsweredSection = sectionIndex;
              }
              break;
            }
            case 'INPUT':
            case 'AGENT_CODE': {
              const answerObj = question.answers[0];
              if (answerObj) {
                values[question.id] = answerObj.answer;
                if (answerObj.preFilled) preFilledQuestions[question.id] = true;
                if (answerObj.creator) {
                  creators[question.id] = {
                    answerId: answerObj.id,
                    ...answerObj.creator
                  };
                }
                if (!answerObj.isRejected && !answerObj.preFilled)
                  lastAnsweredSection = sectionIndex;
              }
              break;
            }
            case 'CHECKBOX':
            case 'CONFIRMATIONS': {
              const answers = question.answers;
              if (answers.length > 0) {
                values[question.id] = answers.map((item) => {
                  if (item.preFilled) preFilledQuestions[question.id] = true;
                  if (item.creator) {
                    creators[question.id] = {
                      answerId: item.id,
                      ...item.creator
                    };
                  }
                  if (!item.isRejected && !item.preFilled) lastAnsweredSection = sectionIndex;
                  return item.availableAnswerId;
                });
              }
              break;
            }
            case 'ADDRESS': {
              const answerObj = question.answers[0];
              if (answerObj) {
                values[question.id] = JSON.parse(answerObj.answer);
                if (answerObj.preFilled) preFilledQuestions[question.id] = true;
                if (answerObj.creator) {
                  creators[question.id] = {
                    answerId: answerObj.id,
                    ...answerObj.creator
                  };
                }
                if (!answerObj.isRejected && !answerObj.preFilled)
                  lastAnsweredSection = sectionIndex;
              }
              break;
            }
            case 'PHONE': {
              const answerObj = question.answers[0];
              if (answerObj) {
                if (answerObj.numberOfSymbolsInCode) {
                  values[question.id] =
                    answerObj.answer.slice(0, answerObj.numberOfSymbolsInCode) +
                    answerObj.answer.slice(answerObj.numberOfSymbolsInCode + 1);
                } else {
                  values[question.id] = answerObj.answer;
                }
                if (answerObj.preFilled) preFilledQuestions[question.id] = true;
                if (answerObj.creator) {
                  creators[question.id] = {
                    answerId: answerObj.id,
                    ...answerObj.creator
                  };
                }
                if (!answerObj.isRejected && !answerObj.preFilled)
                  lastAnsweredSection = sectionIndex;
              }
              break;
            }
            default: {
              const answerObj = question.answers[0];
              if (answerObj) {
                values[question.id] = answerObj.answer;
                if (answerObj.preFilled) preFilledQuestions[question.id] = true;
                if (answerObj.creator) {
                  creators[question.id] = {
                    answerId: answerObj.id,
                    ...answerObj.creator
                  };
                }
                if (!answerObj.isRejected && !answerObj.preFilled)
                  lastAnsweredSection = sectionIndex;
              }
            }
          }
        }
      });

      if (questionGroup.isMultiple && collectedQuestions.length > 0) {
        values[`group_${questionGroup.id}`] = collectedQuestions;
      }
    });
  });

  return { values, lastAnsweredSection, preFilledQuestions, creators };
};

//collect already answered products
const collectProductsAnswers = (product) => {
  const values = {};
  const preFilledQuestions = {};
  let creators = {};
  let lastAnsweredSection = -1;

  product.productSections.forEach((section, sectionIndex) => {
    section.productGroups.forEach((productGroup) => {
      let collectedQuestions = [];

      productGroup.productQuestions.forEach((question) => {
        if (productGroup.isMultiple) {
          switch (question.type) {
            case 'DOC_UPLOAD': {
              try {
                const answers = question.productAnswers;
                if (answers && answers.length > 0) {
                  answers.forEach((answer, index) => {
                    const url = `${API_URL}/${answer.documentURL}`;

                    if (answer.preFilled) {
                      preFilledQuestions[`group_${productGroup.id}.${index}`] = {
                        ...preFilledQuestions[`group_${productGroup.id}.${index}`],
                        [question.id]: true
                      };
                    }

                    if (answer.creator) {
                      creators[question.id] = {
                        answerId: answer.id,
                        ...answer.creator
                      };
                    }

                    !collectedQuestions[index]
                      ? (collectedQuestions[index] = { [question.id]: url })
                      : (collectedQuestions[index][question.id] = url);
                  });

                  if (answers.filter((answer) => !answer.isRejected).length > 0) {
                    lastAnsweredSection = sectionIndex;
                  }
                }
              } catch (e) {}

              break;
            }
            default: {
              const answers = question.productAnswers;
              if (answers && answers.length > 0) {
                answers.forEach((answer, index) => {
                  if (answer.preFilled) {
                    preFilledQuestions[`group_${productGroup.id}.${index}`] = {
                      ...preFilledQuestions[`group_${productGroup.id}.${index}`],
                      [question.id]: true
                    };
                  }

                  if (answer.creator) {
                    creators[question.id] = {
                      answerId: answer.id,
                      ...answer.creator
                    };
                  }

                  !collectedQuestions[index]
                    ? (collectedQuestions[index] = { [question.id]: answer.productAnswer })
                    : (collectedQuestions[index][question.id] = answer.productAnswer);
                });
                if (
                  answers.filter((answer) => !answer.isRejected && !answer.preFilled).length > 0
                ) {
                  lastAnsweredSection = sectionIndex;
                }
              }
            }
          }
        } else {
          switch (question.type) {
            case 'DOC_UPLOAD':
            case 'RECORD_VIDEO':
            case 'SIGNATURE': {
              const answerObj = question.productAnswers[0];
              if (answerObj) {
                values[question.id] = `${API_URL}/${answerObj.documentURL}`;
                if (answerObj.preFilled) preFilledQuestions[question.id] = true;
                if (!answerObj.isRejected && !answerObj.preFilled)
                  lastAnsweredSection = sectionIndex;
                if (answerObj.creator) {
                  creators[question.id] = {
                    answerId: answerObj.id,
                    ...answerObj.creator
                  };
                }
              }
              break;
            }
            case 'RADIO': {
              const answerObj = question.productAnswers[0];
              if (answerObj) {
                values[question.id] = answerObj.productAvailableAnswerId;
                if (answerObj.preFilled) preFilledQuestions[question.id] = true;
                if (!answerObj.isRejected && !answerObj.preFilled)
                  lastAnsweredSection = sectionIndex;
                if (answerObj.creator) {
                  creators[question.id] = {
                    answerId: answerObj.id,
                    ...answerObj.creator
                  };
                }
              }
              break;
            }
            case 'INPUT':
            case 'INTEGER':
            case 'MINIMAL_AMOUNT': {
              const answerObj = question.productAnswers[0];
              if (answerObj) {
                values[question.id] = answerObj.productAnswer;
                if (answerObj.preFilled) preFilledQuestions[question.id] = true;
                if (!answerObj.isRejected && !answerObj.preFilled)
                  lastAnsweredSection = sectionIndex;
                if (answerObj.creator) {
                  creators[question.id] = {
                    answerId: answerObj.id,
                    ...answerObj.creator
                  };
                }
              }
              break;
            }
            case 'CHECKBOX':
            case 'CONFIRMATIONS': {
              const answers = question.productAnswers;
              if (answers.length > 0) {
                values[question.id] = answers.map((item) => {
                  if (item.preFilled) preFilledQuestions[question.id] = true;
                  if (!item.isRejected && !item.preFilled) lastAnsweredSection = sectionIndex;
                  if (item.creator) {
                    creators[question.id] = {
                      answerId: item.id,
                      ...item.creator
                    };
                  }
                  return item.productAvailableAnswerId;
                });
              }
              break;
            }
            case 'ADDRESS': {
              const answerObj = question.productAnswers[0];
              if (answerObj) {
                values[question.id] = JSON.parse(answerObj.productAnswer);
                if (answerObj.preFilled) preFilledQuestions[question.id] = true;
                if (!answerObj.isRejected && !answerObj.preFilled)
                  lastAnsweredSection = sectionIndex;
                if (answerObj.creator) {
                  creators[question.id] = {
                    answerId: answerObj.id,
                    ...answerObj.creator
                  };
                }
              }
              break;
            }
            case 'PHONE': {
              const answerObj = question.productAnswers[0];
              if (answerObj) {
                if (answerObj.numberOfSymbolsInCode) {
                  values[question.id] = [
                    answerObj.productAnswer.slice(0, answerObj.numberOfSymbolsInCode),
                    answerObj.productAnswer.slice(answerObj.numberOfSymbolsInCode + 1)
                  ].join('/');
                } else {
                  values[question.id] = answerObj.productAnswer;
                }
                if (answerObj.preFilled) preFilledQuestions[question.id] = true;
                if (!answerObj.isRejected && !answerObj.preFilled)
                  lastAnsweredSection = sectionIndex;
                if (answerObj.creator) {
                  creators[question.id] = {
                    answerId: answerObj.id,
                    ...answerObj.creator
                  };
                }
              }
              break;
            }
            default: {
              const answerObj = question.productAnswers[0];
              if (answerObj) {
                values[question.id] = answerObj.productAnswer;
                if (answerObj.preFilled) preFilledQuestions[question.id] = true;
                if (!answerObj.isRejected && !answerObj.preFilled)
                  lastAnsweredSection = sectionIndex;
                if (answerObj.creator) {
                  creators[question.id] = {
                    answerId: answerObj.id,
                    ...answerObj.creator
                  };
                }
              }
            }
          }
        }
      });

      if (productGroup.isMultiple && collectedQuestions.length > 0) {
        values[`group_${productGroup.id}`] = collectedQuestions;
      }
    });
  });

  return { values, lastAnsweredSection, preFilledQuestions, creators };
};

//collect current answers before post on back questionnaires
const collectQuestionnaireCurrentAnswers = ({
  filteredQuestionnaire,
  questionnaire,
  currentSection,
  data,
  questionIdKey = 'questionId',
  dirtyFieldsValues
}) => {
  const array = [];
  let fileIndex = 1;
  let answerId = undefined;
  let childQuestionnaireId = undefined;

  const push = ({
    questionId,
    questionName,
    key,
    answer,
    fieldname,
    answerId,
    childQuestionnaireId,
    group = 0,
    prePostCallback = null
  }) =>
    array.push({
      questionSectionTypeId: questionnaire.investorQuestionSectionTypeId,
      questionName: questionName,
      [questionIdKey]: questionId,
      [key]: answer,
      ...(fieldname && { fieldname: fieldname }),
      clearAll: true,
      group: group,
      ...(answerId && { answerId: answerId }),
      key: key,
      prePostCallback: prePostCallback,
      childQuestionnaireId: childQuestionnaireId
    });

  const prePostFile = async (url) => {
    const blobRes = await api.get(url, { responseType: 'blob' });
    if (blobRes.data) {
      const blob = blobRes.data;
      return new File([blob], getFilenameFromUrl(url));
    }
    return null;
  };

  const dirtyFieldsValuesKeys = Object.keys(dirtyFieldsValues);

  const filteredQuestionGroups = filteredQuestionnaire[currentSection].questionGroups.filter(
    (questionGroup) => {
      return questionGroup.questions.find(
        (question) =>
          dirtyFieldsValuesKeys.includes(question.id) ||
          dirtyFieldsValuesKeys.includes(`group_${questionGroup.id}`)
      );
    }
  );

  filteredQuestionGroups.forEach((questionGroup) => {
    const multipleAnswer = data[`group_${questionGroup.id}`];

    const filteredQuestions = questionGroup.questions.filter(
      (question) =>
        dirtyFieldsValuesKeys.includes(question.id) ||
        dirtyFieldsValuesKeys.includes(`group_${questionGroup.id}`)
    );

    filteredQuestions.forEach((question) => {
      const answer = question.answers.find((ans) => ans.questionId === question.id);
      if (answer) answerId = answer.id;
      if (answer) childQuestionnaireId = answer.childQuestionnaireId;

      switch (question.type) {
        case 'DOC_UPLOAD':
        case 'RECORD_VIDEO':
        case 'SIGNATURE': {
          const answer = data[question.id];
          if (answer) {
            push({
              questionId: question.id,
              questionName: questionGroup.title,
              ...(answerId && { answerId: answerId }),
              key: 'file',
              fieldname: `file${fileIndex}`,
              answer: answer,
              prePostCallback: typeof answer === 'string' ? () => prePostFile(answer) : null,
              ...(childQuestionnaireId && { childQuestionnaireId: childQuestionnaireId })
            });
            fileIndex++;
          }

          if (multipleAnswer) {
            multipleAnswer.forEach((answer, index) => {
              if (answer[question.id]) {
                push({
                  questionId: question.id,
                  questionName: questionGroup.title,
                  key: 'file',
                  fieldname: `file${fileIndex}`,
                  ...(answerId && { answerId: answerId }),
                  answer: answer[question.id],
                  group: index + 1,
                  prePostCallback:
                    typeof answer[question.id] === 'string'
                      ? () => prePostFile(answer[question.id])
                      : null,
                  ...(childQuestionnaireId && { childQuestionnaireId: childQuestionnaireId })
                });

                fileIndex++;
              }
            });
          }
          break;
        }
        case 'RADIO': {
          const answer = data[question.id];
          if (answer)
            push({
              questionId: question.id,
              key: 'availableAnswerId',
              answer: answer,
              ...(answerId && { answerId: answerId }),
              ...(childQuestionnaireId && { childQuestionnaireId: childQuestionnaireId })
            });

          if (multipleAnswer) {
            multipleAnswer.forEach((answer, index) => {
              if (answer[question.id]) {
                push({
                  questionId: question.id,
                  key: 'availableAnswerId',
                  answer: answer[question.id],
                  ...(answerId && { answerId: answerId }),
                  group: index + 1,
                  ...(childQuestionnaireId && { childQuestionnaireId: childQuestionnaireId })
                });
              }
            });
          }
          break;
        }
        case 'CHECKBOX':
        case 'CONFIRMATIONS': {
          const answers = data[question.id];
          if (answers && answers.length > 0) {
            answers.forEach((item) => {
              if (item)
                push({
                  questionId: question.id,
                  key: 'availableAnswerId',
                  answer: item,
                  ...(answerId && { answerId: answerId }),
                  ...(childQuestionnaireId && { childQuestionnaireId: childQuestionnaireId })
                });
            });
          }
          break;
        }
        case 'DATE': {
          const answer = data[question.id];
          if (answer)
            push({
              questionId: question.id,
              key: 'answer',
              ...(answerId && { answerId: answerId }),
              answer: typeof answer === 'string' ? answer : answer.toISOString(),
              ...(childQuestionnaireId && { childQuestionnaireId: childQuestionnaireId })
            });
          if (multipleAnswer) {
            multipleAnswer.forEach((answersObj, index) => {
              const answer = answersObj[question.id];
              if (answer) {
                push({
                  questionId: question.id,
                  key: 'answer',
                  ...(answerId && { answerId: answerId }),
                  answer: typeof answer === 'string' ? answer : answer.toISOString(),
                  group: index + 1,
                  ...(childQuestionnaireId && { childQuestionnaireId: childQuestionnaireId })
                });
              }
            });
          }
          break;
        }
        default: {
          const answer = data[question.id];

          if (question.type === 'PHONE' && answer === '/') break;

          if (answer)
            push({
              questionId: question.id,
              key: 'answer',
              ...(answerId && { answerId: answerId }),
              answer: typeof answer === 'string' ? answer : JSON.stringify(answer),
              ...(childQuestionnaireId && { childQuestionnaireId: childQuestionnaireId })
            });
          if (multipleAnswer) {
            multipleAnswer.forEach((answersObj, index) => {
              const answer = answersObj[question.id];
              if (answer)
                push({
                  questionId: question.id,
                  key: 'answer',
                  ...(answerId && { answerId: answerId }),
                  answer: typeof answer === 'string' ? answer : JSON.stringify(answer),
                  group: index + 1,
                  ...(childQuestionnaireId && { childQuestionnaireId: childQuestionnaireId })
                });
            });
          }
        }
      }
    });
  });

  return { array: array };
};

//collect products current answers before post on back
const collectProductsCurrentAnswers = ({
  product,
  currentSection,
  data,
  questionIdKey = 'questionId'
}) => {
  const array = [];
  let oneByOneRequests = false;
  let answerId = undefined;
  let childQuestionnaireId = undefined;

  const push = ({
    questionId,
    questionName,
    key,
    answer,
    answerId,
    childQuestionnaireId,
    group = 0,
    prePostCallback = null
  }) =>
    array.push({
      productQuestionId: questionId,
      investorProductId: product.investorProductId,
      questionName: questionName,
      [questionIdKey]: questionId,
      [key]: answer,
      clearAll: true,
      group: group,
      ...(answerId && { answerId: answerId }),
      key: key,
      prePostCallback: prePostCallback,
      childQuestionnaireId: childQuestionnaireId
    });

  const prePostFile = async (url) => {
    const blobRes = await fetch(url);
    const blob = await blobRes.blob();
    return new File([blob], getFilenameFromUrl(url));
  };

  product.productSections[currentSection].productGroups.forEach((productGroup) => {
    const multipleAnswer = data[`group_${productGroup.id}`];
    if (multipleAnswer) oneByOneRequests = true;

    productGroup.productQuestions.forEach((question) => {
      const answer = question.productAnswers.find((ans) => ans.questionId === question.id);
      if (answer) answerId = answer.id;
      if (answer) childQuestionnaireId = answer.childQuestionnaireId;

      switch (question.type) {
        case 'DOC_UPLOAD':
        case 'RECORD_VIDEO':
        case 'SIGNATURE': {
          const answer = data[question.id];
          if (answer) {
            push({
              questionId: question.id,
              questionName: productGroup.title,
              ...(answerId && { answerId: answerId }),
              key: 'file',
              answer: answer,
              prePostCallback: typeof answer === 'string' ? () => prePostFile(answer) : null,
              ...(childQuestionnaireId && { childQuestionnaireId: childQuestionnaireId })
            });
          }

          if (multipleAnswer) {
            multipleAnswer.forEach((answer, index) => {
              if (answer[question.id]) {
                push({
                  questionId: question.id,
                  questionName: productGroup.title,
                  key: 'file',
                  ...(answerId && { answerId: answerId }),
                  answer: answer[question.id],
                  group: index + 1,
                  prePostCallback:
                    typeof answer[question.id] === 'string'
                      ? () => prePostFile(answer[question.id])
                      : null,
                  ...(childQuestionnaireId && { childQuestionnaireId: childQuestionnaireId })
                });
              }
            });
          }
          break;
        }
        case 'RADIO': {
          const answer = data[question.id];
          if (answer)
            push({
              questionId: question.id,
              key: 'availableAnswerId',
              answer: answer,
              ...(answerId && { answerId: answerId }),
              ...(childQuestionnaireId && { childQuestionnaireId: childQuestionnaireId })
            });

          if (multipleAnswer) {
            multipleAnswer.forEach((answer, index) => {
              if (answer[question.id]) {
                push({
                  questionId: question.id,
                  key: 'availableAnswerId',
                  answer: answer[question.id],
                  ...(answerId && { answerId: answerId }),
                  group: index + 1,
                  ...(childQuestionnaireId && { childQuestionnaireId: childQuestionnaireId })
                });
              }
            });
          }
          break;
        }
        case 'CHECKBOX':
        case 'CONFIRMATIONS': {
          const answers = data[question.id];
          if (answers && answers.length > 0) {
            answers.forEach((item) => {
              if (item)
                push({
                  questionId: question.id,
                  key: 'availableAnswerId',
                  answer: item,
                  ...(answerId && { answerId: answerId }),
                  ...(childQuestionnaireId && { childQuestionnaireId: childQuestionnaireId })
                });
            });
          }
          if (!oneByOneRequests && answers.length > 1) {
            oneByOneRequests = true;
          }
          break;
        }
        case 'DATE': {
          const answer = data[question.id];
          if (answer)
            push({
              questionId: question.id,
              key: 'answer',
              ...(answerId && { answerId: answerId }),
              answer: typeof answer === 'string' ? answer : answer.toISOString(),
              ...(childQuestionnaireId && { childQuestionnaireId: childQuestionnaireId })
            });
          if (multipleAnswer) {
            multipleAnswer.forEach((answersObj, index) => {
              const answer = answersObj[question.id];
              if (answer) {
                push({
                  questionId: question.id,
                  key: 'answer',
                  ...(answerId && { answerId: answerId }),
                  answer: typeof answer === 'string' ? answer : answer.toISOString(),
                  group: index + 1,
                  ...(childQuestionnaireId && { childQuestionnaireId: childQuestionnaireId })
                });
              }
            });
          }
          break;
        }
        default: {
          const answer = data[question.id];

          if (question.type === 'PHONE' && answer === '/') break;

          if (answer)
            push({
              questionId: question.id,
              key: 'answer',
              ...(answerId && { answerId: answerId }),
              answer: typeof answer === 'string' ? answer : JSON.stringify(answer),
              ...(childQuestionnaireId && { childQuestionnaireId: childQuestionnaireId })
            });
          if (multipleAnswer) {
            multipleAnswer.forEach((answersObj, index) => {
              const answer = answersObj[question.id];
              if (answer)
                push({
                  questionId: question.id,
                  key: 'answer',
                  ...(answerId && { answerId: answerId }),
                  answer: typeof answer === 'string' ? answer : JSON.stringify(answer),
                  group: index + 1,
                  ...(childQuestionnaireId && { childQuestionnaireId: childQuestionnaireId })
                });
            });
          }
        }
      }
    });
  });

  return { oneByOneRequests: oneByOneRequests, array: array };
};

const getRejectedObjectUniversal = (entity, rejectedQuestions, entityType = 'questionnaire') => {
  let rejectedObj = null;
  const sectionsIndexes = [];

  const config =
    entityType === 'product'
      ? {
          sectionsKey: 'productSections',
          groupsKey: 'productGroups',
          questionsKey: 'productQuestions',
          questionIdKey: 'productQuestionId'
        }
      : {
          sectionsKey: 'questionSections',
          groupsKey: 'questionGroups',
          questionsKey: 'questions',
          questionIdKey: 'questionId'
        };

  const sections = entity[config.sectionsKey];

  sections.forEach((section, sectionIndex) => {
    let hasRejectedQuestion = false;

    section[config.groupsKey].forEach((group) => {
      group[config.questionsKey].forEach((question) => {
        const rejectObject = rejectedQuestions.filter(
          (item) => item[config.questionIdKey] === question.id
        )[0];

        const result =
          rejectObject?.comment?.[rejectObject?.comment.length - 1]?.comment || 'To update';

        if (rejectObject) {
          hasRejectedQuestion = true;
          rejectedObj
            ? (rejectedObj[question.id] = result)
            : (rejectedObj = { [question.id]: result });
        }
      });
    });

    if (hasRejectedQuestion) sectionsIndexes.push(sectionIndex);
  });

  return { rejectedObj: rejectedObj, sectionsIndexes: sectionsIndexes };
};

const getRejectedObject = (questionnaire, rejectedQuestions) => {
  return getRejectedObjectUniversal(questionnaire, rejectedQuestions, 'questionnaire');
};

const getProductRejectedObject = (product, rejectedQuestions) => {
  return getRejectedObjectUniversal(product, rejectedQuestions, 'product');
};

const conditioningSteps = (watchedFields, conditions, operator) => {
  let isVisible = true;
  if (watchedFields && conditions && Array.from(conditions).length > 0) {
    const hasNestedArrays = watchedFields.every((item) => Array.isArray(item));
    if (operator === 'AND') {
      isVisible = conditions.every((obj) =>
        hasNestedArrays && watchedFields[0]
          ? watchedFields[0].includes(obj.value)
          : watchedFields.includes(obj.value)
      );
    }

    if (operator === 'OR') {
      isVisible = conditions.some((obj) =>
        hasNestedArrays && watchedFields[0]
          ? watchedFields[0].includes(obj.value)
          : watchedFields.includes(obj.value)
      );
    }
  }
  return isVisible;
};

const getRejectedAnswersIds = (obj, questionId, answersIds, newAnswer) => {
  const resultArray = answersIds;
  Object.keys(obj).forEach((key) => {
    if (
      key === 'questionId' &&
      obj[key] === questionId &&
      obj.childQuestionnaireId &&
      obj.answer !== newAnswer.answer
    ) {
      const duplicateIds = resultArray.filter(
        (item) => item.childQuestionnaireId === obj.childQuestionnaireId
      );

      if (duplicateIds.length > 0) {
        duplicateIds.forEach((id) =>
          id.answersIds.push(
            id.status === 'CREATED' || id.status === 'WITHOUT_CHANGE'
              ? newAnswer.id
              : id.status === 'DELETED'
                ? obj.id
                : null
          )
        );
      } else {
        resultArray.push(
          {
            childQuestionnaireId: obj.childQuestionnaireId,
            status: 'CREATED',
            answersIds: [newAnswer.id]
          },
          {
            childQuestionnaireId: obj.childQuestionnaireId,
            status: 'DELETED',
            answersIds: [obj.id]
          }
        );
      }
    }
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      getRejectedAnswersIds(obj[key], questionId, resultArray, newAnswer);
    }
  });
  return resultArray;
};

const collectFixedAnswersIds = (questionnaire, rejectedQuestions, answersArray, savedAnswers) => {
  if (!rejectedQuestions || !savedAnswers || !answersArray) return [];

  const sentQuestionIds = new Set(answersArray.map((answer) => answer.questionId));
  const fixedAnswersIds = [];

  savedAnswers.forEach((item) => {
    if (rejectedQuestions[item.questionId] && item.id && sentQuestionIds.has(item.questionId)) {
      fixedAnswersIds.push(String(item.id));
    }
  });

  return fixedAnswersIds;
};

function getDirtyValues(dirtyFields, allValues) {
  if (dirtyFields === true || Array.isArray(dirtyFields)) return allValues;
  return Object.fromEntries(
    Object.keys(dirtyFields).map((key) => [key, getDirtyValues(dirtyFields[key], allValues[key])])
  );
}

export const kycHelpers = {
  collectQuestionnaireAnswers,
  collectProductsAnswers,
  collectQuestionnaireCurrentAnswers,
  collectProductsCurrentAnswers,
  getRejectedObject,
  getProductRejectedObject,
  getRejectedObjectUniversal,
  conditioningSteps,
  getRejectedAnswersIds,
  collectFixedAnswersIds,
  getDirtyValues
};

export * from './answerProcessing';
export * from './productAnswerProcessing';
